import React, { useEffect, useState } from "react";
import { Button, Table, Card, CardBody, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCircle, FaSearch, FaUser } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ResourcesAsigServices } from "../GanttDx/ResourcesAsig/ResourcesAsigServices";
import { DeliveryDashboardServices } from "../pharos/DeliveryDashboardServices";
import _ from "lodash";

const AvailableResourceCluster = ({ resources, IdCluster, setKey, loadDataByFilter,filterApply }) => {
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [dataResults, setDataResults] = useState([]);
  const [dataFilter, setDataFilter] = useState({})
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {

    try {
      setLoading(true);
      const year = selectedMonth.getFullYear();
   
      const month = selectedMonth.getMonth();
      const from_date = new Date(year, month, 1);
      const to_date = new Date(year, month + 1, 0); 
      const data = {
      IdCluster : IdCluster,
      start_date:from_date,
      end_date:to_date
      }
        const result = await ResourcesAsigServices.getDataClusterByFilter(data);
        setDataFilter(result.filterApp)
        const results = _(result.task)
        .groupBy('NombreUsuario')
        .map((activities, recurso) => {
            
            const diasHabiles = result.availableHours.DiasCapacidad; // Assuming a constant for calculation
            const horasHabiles = result.availableHours.HorasCapacidad;

            const horasAsignadas = _.sumBy(activities, 'HorasPlaneadasFiltro');
            const horasEjecutadas = _.sumBy(activities, 'HorasRealesFiltro');
            const horasDisponibles = horasHabiles - horasAsignadas;

            const cantProyectos = _.uniqBy(activities, 'IdProyecto').length;
            const cantActividades = activities.length;
            const idUsuario = _.uniqBy(activities, 'IdUsuario')[0]?.IdUsuario

            return {
                IdUsuario: idUsuario,
                Recurso: recurso,
                DiasHabiles: diasHabiles,
                HorasHabiles: horasHabiles,
                HorasAsignadas: _.round(horasAsignadas, 2),
                HorasEjecutadas: _.round(horasEjecutadas, 2),
                HorasDisponibles: _.round(horasDisponibles, 2),
                CantProyectos: cantProyectos,
                CantActividades: cantActividades,
            };
        })
        .value();

    setDataResults(results)
        
    } catch (error) {
      Swal.fire("Error", error, "error");
    } finally {
      setLoading(false);
      setSelectedMonth(new Date());
    }
  };

  
  const Indicator = ({ cap, ocu, hideColor }) => {
    // Calcula el porcentaje. Si cap es 0 se evita la división.
    const percent = cap !== 0 ? parseFloat(((ocu / cap) * 100).toFixed(1)) : 0;

    // Variables para el color y el texto que se mostrarán según el porcentaje
    let color;
    let label;

    if (percent >= 0 && percent < 31) {
      color = "green";
      label = "Subutilizado";
    } else if (percent >= 31 && percent < 61) {
      color = "yellow";
      label = "Moderado";
    } else if (percent >= 61 && percent < 91) {
      color = "orange";
      label = "Alta ocupación";
    } else if (percent >= 91) {
      color = "red";
      label = "Sobreutilizado";
    } else {
      // Caso adicional para valores fuera de rango
      color = "gray";
      label = "Sin datos";
    }

    return (
      <div className="flex items-center">
        { hideColor ?  <span>
           ({percent}%)
        </span> : 
        <>
        <FaCircle color={color} style={{ marginRight: "8px" }} />
        {label}
        </>
         }
      </div>
    );
  };

  useEffect(()=>{
    handleSearch()
  },[])

  const handleView = async (item)=>{

    const data = {
    IdCluster: IdCluster,
    Idrol: "0",
    position: "",
    IdUser: item.IdUsuario || null,
    start_date: dataFilter? dataFilter.start : new Date(),
    end_date: dataFilter? dataFilter.end : new Date(),

    }

    const result  = await loadDataByFilter(data)
    if(result){
      setKey("resources")
    }
  }

  return (
    <>
      <Card className="shadow-sm mb-4">
        <Card.Header className="bg-light">
          <h5 className="mb-0">
            <FaUser size={16} className="mr-2 text-primary" />
            Recurso
          </h5>
        </Card.Header>
        <Card.Body>
          <div className="d-flex gap-5">
            <DatePicker
              selected={selectedMonth}
              onChange={(date) => setSelectedMonth(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="form-control shadow-sm "
            />

            <Button
              className="ml-2"
              variant="primary"
              onClick={handleSearch}
            >
              <FaSearch size={14} /> Buscar
            </Button>

          </div>
          <div className="mt-3">
            {dataFilter  &&
            <b>Periodo : {DeliveryDashboardServices.getformaDate(dataFilter?.start)} | {DeliveryDashboardServices.getformaDate(dataFilter?.end)}</b>
            }
          </div>
          {loading && (
            <div className="text-center mt-2">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {dataResults.length > 0 ? 
            
            <Table striped bordered hover className="mt-3" size="sm">
              <thead>
                <tr>
                  <th>Recurso</th>
                  <th>Proyectos</th>
                  <th>Actividades</th>
                  <th>Días Hábiles</th>
                  <th>Hrs Hábiles</th>
                  <th>Hrs Asignadas</th>
                  <th>Hrs Ejecutadas</th>
                  <th>Hrs Disponibles</th>
                  <th>Indicador</th>
                  <th>Ocupación</th>
                  <th>Detalle</th>
                </tr>
              </thead>
              <tbody>
                {dataResults?.map((item, idx) => (
                  
                  <tr key={idx}>
                    <td className="text-center">{item.Recurso}</td>
                    <td className="text-center">{item.CantProyectos}</td>
                    <td className="text-center">{item.CantActividades}</td>
                    <td className="text-center">{item.DiasHabiles}</td>
                    <td className="text-center">{item.HorasHabiles}</td>
                    <td className="text-center">{item.HorasAsignadas}</td>
                    <td className="text-center">{item.HorasEjecutadas}</td>
                    <td className="text-center">{item.HorasDisponibles}</td>
                    <td className="text-center">
                      <Indicator
                        cap={item.HorasHabiles}
                        ocu={item.HorasAsignadas}
                      />
                    </td>
                    <td className="text-center">
                      <Indicator
                        cap={item.HorasHabiles}
                        ocu={item.HorasAsignadas}
                        hideColor
                      />
                    </td>
                    <td className="text-center" onClick={()=>handleView(item)}><u style={{cursor:"pointer"}} className="text-danger ">Ver</u></td>
                  </tr>
                ))}
              </tbody>
            </Table>
            :
            <>
            </>
          }
        </Card.Body>
      </Card>
    </>
  );
};

export default AvailableResourceCluster;
